(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mcp-hadrill-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.sliderReady) return;
    root.dataset.sliderReady='true';
    var track=root.querySelector('.hrev-slider__track');
    var controls=root.querySelector('.hrev-slider__controls');
    var prev=root.querySelector('[data-review-prev]');
    var next=root.querySelector('[data-review-next]');
    var reviews=Array.from(root.querySelectorAll('.hrev-slider__body')).map(function(body){
      var button=body.nextElementSibling;
      button.addEventListener('click',function(){
        var expanded=button.getAttribute('aria-expanded')!=='true';
        button.setAttribute('aria-expanded',String(expanded));
        button.textContent=expanded?button.dataset.less:button.dataset.more;
        body.classList.toggle('is-collapsed',!expanded);
      });
      return {body:body,button:button};
    });
    function updateReviews(){
      reviews.forEach(function(review){
        var expanded=review.button.getAttribute('aria-expanded')==='true';
        review.body.classList.toggle('is-collapsed',!expanded);
        var overflows=review.body.scrollHeight>parseFloat(getComputedStyle(review.body).lineHeight)*5+2;
        review.button.hidden=!overflows;
        if(!overflows) review.body.classList.remove('is-collapsed');
      });
    }
    function update(){
      var max=track.scrollWidth-track.clientWidth;
      controls.hidden=max<2;
      prev.disabled=track.scrollLeft<2;
      next.disabled=track.scrollLeft>=max-2;
    }
    function move(direction){
      var card=track.querySelector('.hrev-slider__card');
      if(!card) return;
      var gap=parseFloat(getComputedStyle(track).gap)||0;
      track.scrollBy({left:direction*(card.getBoundingClientRect().width+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    }
    prev.addEventListener('click',function(){move(-1)});
    next.addEventListener('click',function(){move(1)});
    track.addEventListener('scroll',update,{passive:true});
    track.addEventListener('keydown',function(e){if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1)}});
    var observer=new ResizeObserver(function(){update();updateReviews()}); observer.observe(track);
    if(document.fonts) document.fonts.ready.then(updateReviews);
    updateReviews();
    root.addEventListener('shopify:section:unload',function(){observer.disconnect()},{once:true});
    update();
  }
  function boot(){document.querySelectorAll('.hrev-slider').forEach(init)}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();
})();
